/**
 * @generated SignedSource<<4c4259d7ff09c89f74f55b631dee8ec7>>
 * @relayHash 183643411deb6fbbe5dafd9ac00c4b97
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 183643411deb6fbbe5dafd9ac00c4b97

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoimmuneDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Cancer = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Diabetes = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES_DIABETES_TYPE_ONE" | "YES_DIABETES_TYPE_ONE_AND_TWO" | "YES_DIABETES_TYPE_TWO";
export type HeartDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Ch_updatePatientFamilyHistoryInput = {
  autoimmuneDisease: AutoimmuneDisease;
  cancer: Cancer;
  comment?: string | null;
  diabetes: Diabetes;
  heartDisease: HeartDisease;
  patientId: string;
};
export type chUpdatePatientFamilyHistoryMutation$variables = {
  input: Ch_updatePatientFamilyHistoryInput;
};
export type chUpdatePatientFamilyHistoryMutation$data = {
  readonly updatePatientFamilyHistory: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly familyHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"FamilyHistoryFragment">;
    } | null;
  };
};
export type chUpdatePatientFamilyHistoryMutation = {
  response: chUpdatePatientFamilyHistoryMutation$data;
  variables: chUpdatePatientFamilyHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdatePatientFamilyHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientFamilyHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientFamilyHistoryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientFamilyHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FamilyHistoryFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdatePatientFamilyHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientFamilyHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientFamilyHistoryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientFamilyHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyHistory",
            "kind": "LinkedField",
            "name": "familyHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "autoimmuneDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heartDisease",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diabetes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "183643411deb6fbbe5dafd9ac00c4b97",
    "metadata": {},
    "name": "chUpdatePatientFamilyHistoryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8ab88297cdd718d409c075ef646f0a90";

export default node;
